/**
 * Multiple Media With Text Component
 * Handles reveal-on-scroll animation for multiple media sections
 */
if (!window.customElements.get("multiple-media-with-text")) {
  class MultipleMediaWithText extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const revealOnScroll = this.getAttribute("reveal-on-scroll") === "true";
      const prefersMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;

      if (revealOnScroll && prefersMotion) {
        this.setupRevealOnScroll();
      } else {
        this.style.opacity = "1";
      }
    }

    setupRevealOnScroll() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.style.opacity = "0";
              this.style.transition = "opacity 0.8s ease";
              requestAnimationFrame(() => {
                this.style.opacity = "1";
              });
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0.05 }
      );

      observer.observe(this);
    }
  }

  window.customElements.define("multiple-media-with-text", MultipleMediaWithText);
}

